import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const ResultsIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg width="25px" height="24px" viewBox="0 0 25 24" {...rest}>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Overrides/Icons/Results" stroke={color} strokeWidth="2">
          <g id="Group" transform="translate(1.000000, 1.000000)">
            <path
              d="M22.4099135,13.9853932 L15.141512,21.2827023 L11.569699,22 L12.2840616,18.4135113 L19.552463,11.1162022 C19.9300049,10.7364062 20.442482,10.5229798 20.9769021,10.5229798 C21.5113222,10.5229798 22.0237993,10.7364062 22.4013411,11.1162022 L22.4099135,11.1238534 C23.1966955,11.9141194 23.1966955,13.1951272 22.4099135,13.9853932 L22.4099135,13.9853932 Z"
              id="Path"
            ></path>
            <path
              d="M7.61986787,21.9971308 L0.952483484,21.9971308 C0.426441381,21.9971308 0,21.5689373 0,21.0407338 L0,0.956396992 C0,0.428193518 0.426441381,0 0.952483484,0 L13.610989,0 C13.8655363,0.0010610502 14.1090698,0.104385332 14.2872523,0.286919098 L17.8114411,3.82558797 C17.9900788,4.00490545 18.0905188,4.24812912 18.0905188,4.50176064 L18.0905188,7.65117593"
              id="Path"
            ></path>
            <line x1="3.8976769" y1="14.3488241" x2="10.3838605" y2="14.3488241" id="Path"></line>
            <path
              d="M5.84141886,8.06024059 L7.09341758,8.06024059 C7.43914748,8.06024059 7.71941694,8.3416616 7.71941694,8.68881202 L7.71941694,14.3459549 L5.2154195,14.3459549 L5.2154195,8.68881202 C5.2154195,8.3416616 5.49568896,8.06024059 5.84141886,8.06024059 Z"
              id="Path"
            ></path>
            <path
              d="M13.3347688,10.1554787 L13.3347688,6.66341519 C13.3347688,6.27769251 13.0233583,5.96500249 12.6392139,5.96500249 L11.2481042,5.96500249 C10.8639599,5.96500249 10.5525494,6.27769251 10.5525494,6.66341519 L10.5525494,14.3459549"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
